import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import SettingsField from 'ui-library/SettingsField';

export function shouldShowWarehouseName(): boolean {
  return BenchlingConfig.SCHEMAS_ENABLE_VIEW_SYSTEM_NAME;
}

interface SchemaWarehouseNameFieldProps {
  isWritable: boolean;
  forContainerSchema?: boolean;
  onChange: (sqlIdentifier: string) => void;
  sqlIdentifier: string;
}

export default function SchemaWarehouseNameField(props: SchemaWarehouseNameFieldProps): JSX.Element | null {
  return shouldShowWarehouseName() ? (
    <SettingsField
      isBeingCreated={false}
      isWritable={BenchlingConfig.SCHEMAS_ENABLE_CHANGE_WAREHOUSE_NAME && props.isWritable}
      label="System name"
      name="warehouse_name"
      onChange={props.onChange}
      value={props.sqlIdentifier}
      withLabelBottomMargin={!props.forContainerSchema}
    />
  ) : null;
}

SchemaWarehouseNameField.defaultProps = {
  forContainerSchema: false,
};

interface ReadOnlyWarehouseNameFieldProps {
  forContainerSchema?: boolean;
  sqlIdentifier: string;
}

export function ReadOnlyWarehouseNameField(props: ReadOnlyWarehouseNameFieldProps): JSX.Element | null {
  return (
    <SchemaWarehouseNameField
      onChange={() => {}}
      isWritable={false}
      forContainerSchema={props.forContainerSchema}
      sqlIdentifier={props.sqlIdentifier}
    />
  );
}
